// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Tab wrapper ──────────────────────────────────────────────────────────── */

.ivr-flow-tab {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 24px;
}

.fc-header h2 { margin: 0 0 4px; }
.fc-subtitle   { margin: 0; font-size: 13px; color: #64748b; }
.fc-loading    { color: #64748b; font-size: 14px; }

.fc-error {
  padding: 12px 16px;
  background: #fff0f0;
  border: 1px solid #fca5a5;
  border-radius: 6px;
  color: #b91c1c;
  font-size: 13px;
}

/* ── Chart container: single centered column ─────────────────────────────── */

.fc-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
}

/* ── Pill (start / end terminal) ─────────────────────────────────────────── */

.fc-pill {
  padding: 8px 28px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-align: center;
  border: 2px solid transparent;
}

.fc-pill-start {
  background: #dbeafe;
  border-color: #3b82f6;
  color: #1e40af;
}

.fc-pill-success {
  background: #dcfce7;
  border-color: #22c55e;
  color: #15803d;
}

/* ── Process box ─────────────────────────────────────────────────────────── */

.fc-box {
  width: 360px;
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-left-width: 4px;
  border-radius: 6px;
  padding: 10px 14px;
  box-sizing: border-box;
}

.fc-box-header {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.fc-box-title {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
}

.fc-box-badge {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 8px;
  background: #f1f5f9;
  color: #64748b;
  font-weight: 500;
}

.fc-box-text {
  margin: 0;
  font-size: 12px;
  color: #475569;
  line-height: 1.5;
}

.fc-expand {
  background: none;
  border: none;
  padding: 0;
  font-size: 11px;
  color: #3b82f6;
  cursor: pointer;
  text-decoration: underline;
  margin-left: 2px;
}

/* Box accent colours */
.fc-box-blue   { border-left-color: #3b82f6; }
.fc-box-purple { border-left-color: #8b5cf6; }
.fc-box-green  { border-left-color: #22c55e; }
.fc-box-amber  { border-left-color: #f59e0b; }

/* Conditional / disabled step styling */
.fc-box-conditional {
  border-style: dashed;
}
.fc-box-disabled {
  opacity: 0.45;
  border-left-color: #94a3b8;
}
.fc-badge-conditional {
  background: #fef3c7 !important;
  color: #92400e !important;
}
.fc-badge-disabled {
  background: #fee2e2 !important;
  color: #991b1b !important;
}

/* ── Vertical arrow ──────────────────────────────────────────────────────── */

.fc-arrow {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-height: 36px;
  position: relative;
}

.fc-arrow-label {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: #fff;
  padding: 0 4px;
  position: relative;
  z-index: 1;
}

/* Vertical line + arrowhead drawn with pseudo-elements */
.fc-arrow::before {
  content: '';
  width: 2px;
  flex: 1;
  min-height: 16px;
  background: #94a3b8;
}

.fc-arrow::after {
  content: '';
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 7px solid #94a3b8;
}

/* ── Decision diamond ────────────────────────────────────────────────────── */

.fc-diamond-wrap {
  display: flex;
  justify-content: center;
  padding: 6px 0;
}

.fc-diamond {
  width: 118px;
  height: 118px;
  background: #fffbeb;
  border: 2px solid #f59e0b;
  border-radius: 4px;
  transform: rotate(45deg);
  display: flex;
  align-items: center;
  justify-content: center;
}

.fc-diamond-text {
  transform: rotate(-45deg);
  font-size: 11px;
  font-weight: 700;
  color: #78350f;
  text-align: center;
  max-width: 88px;
  line-height: 1.3;
  padding: 4px;
}

/* ── Branch row below a diamond ──────────────────────────────────────────── */

.fc-branch-row {
  display: grid;
  grid-template-columns: 1fr 60px 1fr;
  width: 520px;
  align-items: start;
}

/* Left branch column */
.fc-branch-left {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  padding-right: 0;
}

/* Right branch column */
.fc-branch-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding-left: 0;
}

/* Center column — just the continue arrow */
.fc-branch-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fc-branch-empty {
  min-width: 1px;
}

/* Branch label sits above the horizontal line */
.fc-branch-label-left,
.fc-branch-label-right {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 0 4px;
}

.fc-branch-label-left  { text-align: right; }
.fc-branch-label-right { text-align: left; }

/* L-shaped line: horizontal + vertical */
.fc-branch-lines-left {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.fc-branch-lines-right {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
}

.fc-branch-h {
  height: 2px;
  width: 48px;
  background: #94a3b8;
  margin-top: 16px;   /* align with center of the arrow line */
}

.fc-branch-v {
  width: 2px;
  height: 28px;
  background: #94a3b8;
}

/* ── Terminal nodes (hangup / voicemail / goodbye / retry) ───────────────── */

.fc-terminal {
  font-size: 11px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 4px;
  text-align: center;
  white-space: nowrap;
  border: 1.5px solid transparent;
}

.fc-terminal-hangup {
  background: #fee2e2;
  border-color: #fca5a5;
  color: #991b1b;
}

.fc-terminal-voicemail {
  background: #f3e8ff;
  border-color: #c4b5fd;
  color: #5b21b6;
}

.fc-terminal-goodbye {
  background: #fef3c7;
  border-color: #fcd34d;
  color: #78350f;
}

.fc-terminal-retry {
  background: #dbeafe;
  border-color: #93c5fd;
  color: #1e40af;
}

/* ── Voicemail terminal: make it a button that scrolls ───────────────────── */

.fc-terminal-link {
  cursor: pointer;
  background: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  border-width: 1.5px;
  border-style: solid;
}

.fc-terminal-link:hover {
  filter: brightness(0.94);
}

.fc-terminal-hint {
  font-size: 9px;
  font-weight: 400;
  opacity: 0.7;
  letter-spacing: 0.02em;
}

/* ── Voicemail template panel ────────────────────────────────────────────── */

.vm-panel {
  background: #fff;
  border: 1.5px solid #e9d5ff;
  border-radius: 10px;
  overflow: hidden;
  scroll-margin-top: 16px;
}

.vm-panel-header {
  background: #faf5ff;
  border-bottom: 1px solid #e9d5ff;
  padding: 14px 18px 10px;
}

.vm-panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 14px;
  color: #3b0764;
  margin-bottom: 4px;
}

.vm-panel-icon { font-size: 18px; }

.vm-panel-key {
  font-family: monospace;
  font-size: 11px;
  background: #ede9fe;
  color: #5b21b6;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
}

.vm-panel-desc {
  margin: 0 0 8px;
  font-size: 12px;
  color: #6b21a8;
}

.vm-placeholders {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.vm-ph-label {
  font-size: 11px;
  color: #7c3aed;
  font-weight: 600;
}

.vm-ph-chip {
  font-family: monospace;
  font-size: 11px;
  background: #ede9fe;
  color: #5b21b6;
  padding: 1px 6px;
  border-radius: 4px;
  cursor: default;
}

/* Individual template row */
.vm-row {
  padding: 12px 18px;
  border-bottom: 1px solid #f3f4f6;
}

.vm-row:last-of-type { border-bottom: none; }

.vm-row-inactive { opacity: 0.55; }

.vm-row-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  gap: 8px;
}

.vm-row-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 6px;
}

.vm-badge-inactive {
  font-size: 10px;
  padding: 1px 6px;
  background: #fee2e2;
  color: #b91c1c;
  border-radius: 8px;
  font-weight: 500;
}

.vm-row-actions {
  display: flex;
  gap: 6px;
}

.vm-row-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.vm-lang-row {
  display: flex;
  gap: 8px;
  font-size: 13px;
  align-items: baseline;
}

.vm-lang {
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  min-width: 24px;
  flex-shrink: 0;
}

.vm-missing {
  font-size: 12px;
  color: #94a3b8;
  font-style: italic;
  margin: 0;
}

/* Edit form */
.vm-edit-form,
.vm-new-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 12px;
  margin-top: 6px;
}

.vm-new-form {
  margin: 12px 18px;
}

.vm-new-form-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 2px;
}

.vm-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.vm-field label {
  font-size: 11px;
  font-weight: 600;
  color: #475569;
}

.vm-hint {
  font-weight: 400;
  color: #94a3b8;
}

.vm-field textarea,
.vm-field input[type='number'] {
  padding: 6px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  background: #fff;
  color: #1e293b;
}

.vm-field textarea:focus,
.vm-field input:focus {
  outline: none;
  border-color: #8b5cf6;
  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.15);
}

.vm-form-actions {
  display: flex;
  gap: 8px;
}

/* Inactive section */
.vm-inactive-section {
  padding: 8px 18px;
  border-bottom: 1px solid #f3f4f6;
}

.vm-inactive-section summary {
  font-size: 12px;
  color: #94a3b8;
  cursor: pointer;
}

/* Notifications */
.vm-success {
  padding: 6px 10px;
  background: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: 4px;
  color: #166534;
  font-size: 12px;
  margin-bottom: 4px;
}

.vm-error {
  padding: 6px 10px;
  background: #fff0f0;
  border: 1px solid #fca5a5;
  border-radius: 4px;
  color: #b91c1c;
  font-size: 12px;
  margin-bottom: 4px;
}

.vm-loading {
  font-size: 13px;
  color: #64748b;
  padding: 12px 18px;
}

/* Shared buttons */
.vm-btn-edit {
  padding: 3px 10px;
  font-size: 12px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  cursor: pointer;
  color: #374151;
}
.vm-btn-edit:hover { border-color: #8b5cf6; color: #5b21b6; }

.vm-btn-deactivate {
  padding: 3px 10px;
  font-size: 12px;
  background: #fff;
  border: 1px solid #fca5a5;
  border-radius: 4px;
  cursor: pointer;
  color: #b91c1c;
}
.vm-btn-deactivate:hover { background: #fff0f0; }

.vm-btn-save {
  padding: 5px 16px;
  background: #7c3aed;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}
.vm-btn-save:hover:not(:disabled) { background: #6d28d9; }
.vm-btn-save:disabled { opacity: 0.6; cursor: not-allowed; }

.vm-btn-cancel {
  padding: 5px 14px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  color: #374151;
}
.vm-btn-cancel:hover { border-color: #94a3b8; }

.vm-btn-add {
  display: block;
  width: calc(100% - 36px);
  margin: 10px 18px;
  padding: 7px;
  background: #fff;
  border: 1px dashed #c4b5fd;
  border-radius: 4px;
  font-size: 12px;
  color: #5b21b6;
  cursor: pointer;
  text-align: center;
}
.vm-btn-add:hover { background: #faf5ff; border-color: #8b5cf6; }

/* ── Transfer terminal ─────────────────────────────────────────────────────── */

.fc-terminal-transfer {
  background: #dbeafe;
  border-color: #93c5fd;
  color: #1e40af;
}

/* ── Company selector ──────────────────────────────────────────────────────── */

.fc-company-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}

.fc-company-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  white-space: nowrap;
}

.fc-company-input {
  width: 120px;
  padding: 5px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  font-size: 13px;
  font-family: inherit;
  background: #fff;
  color: #1e293b;
}
.fc-company-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

/* ── Searchable company combobox ─────────────────────────────────────────── */

.fc-company-combo {
  position: relative;
  flex: 1 1 auto;
  max-width: 380px;
}

.fc-company-search {
  width: 100%;
  box-sizing: border-box;
}
.fc-company-search:disabled {
  background: #f1f5f9;
  color: #94a3b8;
  cursor: not-allowed;
}

.fc-company-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 30;
  margin: 0;
  padding: 4px;
  list-style: none;
  max-height: 280px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.15);
}

.fc-company-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 7px 10px;
  border-radius: 4px;
  font-size: 13px;
  color: #1e293b;
  cursor: pointer;
}
.fc-company-option-active {
  background: #eff6ff;
}
.fc-company-option-selected {
  font-weight: 600;
}
.fc-company-option-selected .fc-company-option-name::before {
  content: '\\2713\\00a0';
  color: #2563eb;
}

.fc-company-option-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fc-company-option-id {
  flex: none;
  font-size: 11px;
  color: #94a3b8;
  font-variant-numeric: tabular-nums;
}

.fc-company-empty,
.fc-company-more {
  padding: 8px 10px;
  font-size: 12px;
  color: #94a3b8;
}
.fc-company-more {
  border-top: 1px solid #f1f5f9;
  margin-top: 2px;
}

.fc-company-loading {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}

.fc-company-btn {
  padding: 5px 14px;
  font-size: 12px;
  font-weight: 600;
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.fc-company-btn:hover:not(:disabled) { background: #2563eb; }
.fc-company-btn:disabled { opacity: 0.6; cursor: not-allowed; }

.fc-company-btn-clear {
  background: #fff;
  color: #64748b;
  border: 1px solid #e2e8f0;
}
.fc-company-btn-clear:hover:not(:disabled) { background: #f1f5f9; border-color: #94a3b8; }

.fc-company-banner {
  padding: 8px 14px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  font-size: 13px;
  color: #1e40af;
}

/* ── Config summary panel ──────────────────────────────────────────────────── */

.fc-config-panel {
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.fc-config-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.fc-config-title {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
}

.fc-config-source {
  font-size: 11px;
  padding: 2px 8px;
  background: #dbeafe;
  color: #1e40af;
  border-radius: 8px;
  font-weight: 500;
}

.fc-config-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 1px;
  background: #f1f5f9;
  padding: 1px;
}

.fc-config-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  background: #fff;
  font-size: 12px;
}

.fc-config-override {
  background: #fffbeb;
}

.fc-config-label {
  color: #64748b;
  font-weight: 500;
}

.fc-config-value {
  color: #1e293b;
  font-weight: 600;
  font-family: monospace;
  font-size: 12px;
}

.fc-config-toggle {
  font-weight: 600;
  font-size: 11px;
  padding: 1px 6px;
  border-radius: 4px;
}
.fc-toggle-on { background: #dcfce7; color: #166534; }
.fc-toggle-off { background: #fee2e2; color: #991b1b; }

.fc-config-sections {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  padding: 8px 14px;
  border-top: 1px solid #e2e8f0;
}

.fc-config-sections-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
}

.fc-config-section-chip {
  font-family: monospace;
  font-size: 11px;
  padding: 1px 6px;
  background: #f1f5f9;
  color: #334155;
  border-radius: 4px;
}

/* ── Optional sections panel ───────────────────────────────────────────────── */

.fc-sections-panel {
  background: #fff;
  border: 1.5px solid #e9d5ff;
  border-radius: 8px;
  overflow: hidden;
}

.fc-sections-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: #faf5ff;
  border-bottom: 1px solid #e9d5ff;
}

.fc-sections-title {
  font-size: 13px;
  font-weight: 700;
  color: #3b0764;
}

.fc-sections-count {
  font-size: 11px;
  color: #6b21a8;
}

.fc-sections-list {
  padding: 4px 0;
}

.fc-section-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 16px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 12px;
}
.fc-section-row:last-child { border-bottom: none; }

.fc-section-order {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ede9fe;
  color: #5b21b6;
  border-radius: 50%;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
}

.fc-section-key {
  font-family: monospace;
  font-size: 11px;
  color: #64748b;
  min-width: 120px;
}

.fc-section-label {
  flex: 1;
  color: #1e293b;
  font-weight: 500;
}

.fc-section-qcount {
  font-size: 11px;
  color: #64748b;
  font-weight: 600;
  padding: 1px 6px;
  background: #f1f5f9;
  border-radius: 8px;
}

/* ── Per-company question customizer ─────────────────────────────────────── */
.qc-panel {
  margin-top: 24px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}
.qc-panel.qc-empty {
  color: #64748b;
  font-size: 13px;
  background: #f8fafc;
}
.qc-header {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 12px;
}
.qc-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}
.qc-sub {
  font-size: 12px;
  color: #64748b;
}
.qc-row {
  padding: 10px 0;
  border-top: 1px solid #eef2f7;
}
.qc-row:first-of-type {
  border-top: none;
}
.qc-row-off {
  opacity: 0.6;
}
.qc-row-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.qc-row-id {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.qc-ident {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  color: #0f172a;
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 6px;
}
.qc-section {
  font-size: 11px;
  color: #64748b;
}
.qc-badge-override,
.qc-badge-required,
.qc-badge-off {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 1px 6px;
  border-radius: 8px;
}
.qc-badge-override { background: #dbeafe; color: #1d4ed8; }
.qc-badge-required { background: #f1f5f9; color: #64748b; }
.qc-badge-off      { background: #fee2e2; color: #b91c1c; }
.qc-row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.qc-text {
  margin: 6px 0 0;
  font-size: 13px;
  color: #334155;
}
/* Toggle switch */
.qc-switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 20px;
}
.qc-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.qc-switch-slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #cbd5e1;
  border-radius: 20px;
  transition: 0.2s;
}
.qc-switch-slider::before {
  content: '';
  position: absolute;
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background: #fff;
  border-radius: 50%;
  transition: 0.2s;
}
.qc-switch input:checked + .qc-switch-slider {
  background: #16a34a;
}
.qc-switch input:checked + .qc-switch-slider::before {
  transform: translateX(18px);
}
.qc-switch input:disabled + .qc-switch-slider {
  opacity: 0.5;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/tabs/IvrFlowTab.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA,gBAAgB,eAAe,EAAE;AACjC,iBAAiB,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE;AAC7D,iBAAiB,cAAc,EAAE,eAAe,EAAE;;AAElD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;AACR;;AAEA,+EAA+E;;AAE/E;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB,iBAAiB,0BAA0B,EAAE;AAC7C,iBAAiB,0BAA0B,EAAE;AAC7C,iBAAiB,0BAA0B,EAAE;AAC7C,iBAAiB,0BAA0B,EAAE;;AAE7C,wCAAwC;AACxC;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,UAAU;EACV,OAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,gDAAgD;AAChD;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,yBAAyB,iBAAiB,EAAE;AAC5C,yBAAyB,gBAAgB,EAAE;;AAE3C,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,gBAAgB,IAAI,wCAAwC;AAC9D;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+EAA+E;;AAE/E;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB,eAAe,EAAE;;AAElC;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,uBAAuB,mBAAmB,EAAE;;AAE5C,mBAAmB,aAAa,EAAE;;AAElC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA,cAAc;AACd;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA,qBAAqB,qBAAqB,EAAE,cAAc,EAAE;;AAE5D;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA,oCAAoC,mBAAmB,EAAE;AACzD,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;;AAE3D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA,uBAAuB,qBAAqB,EAAE;;AAE9C;EACE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA,oBAAoB,mBAAmB,EAAE,qBAAqB,EAAE;;AAEhE,iFAAiF;;AAEjF;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iFAAiF;;AAEjF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA,uCAAuC,mBAAmB,EAAE;AAC5D,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA,6CAA6C,mBAAmB,EAAE,qBAAqB,EAAE;;AAEzF;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,iFAAiF;;AAEjF;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;;AAEtD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,iFAAiF;;AAEjF;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;AACA,6BAA6B,mBAAmB,EAAE;;AAElD;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,2DAA2D;EAC3D,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/* ── Tab wrapper ──────────────────────────────────────────────────────────── */\n\n.ivr-flow-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding-bottom: 24px;\n}\n\n.fc-header h2 { margin: 0 0 4px; }\n.fc-subtitle   { margin: 0; font-size: 13px; color: #64748b; }\n.fc-loading    { color: #64748b; font-size: 14px; }\n\n.fc-error {\n  padding: 12px 16px;\n  background: #fff0f0;\n  border: 1px solid #fca5a5;\n  border-radius: 6px;\n  color: #b91c1c;\n  font-size: 13px;\n}\n\n/* ── Chart container: single centered column ─────────────────────────────── */\n\n.fc-chart {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0;\n}\n\n/* ── Pill (start / end terminal) ─────────────────────────────────────────── */\n\n.fc-pill {\n  padding: 8px 28px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-align: center;\n  border: 2px solid transparent;\n}\n\n.fc-pill-start {\n  background: #dbeafe;\n  border-color: #3b82f6;\n  color: #1e40af;\n}\n\n.fc-pill-success {\n  background: #dcfce7;\n  border-color: #22c55e;\n  color: #15803d;\n}\n\n/* ── Process box ─────────────────────────────────────────────────────────── */\n\n.fc-box {\n  width: 360px;\n  background: #fff;\n  border: 1.5px solid #e2e8f0;\n  border-left-width: 4px;\n  border-radius: 6px;\n  padding: 10px 14px;\n  box-sizing: border-box;\n}\n\n.fc-box-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-bottom: 4px;\n}\n\n.fc-box-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.fc-box-badge {\n  font-size: 10px;\n  padding: 1px 6px;\n  border-radius: 8px;\n  background: #f1f5f9;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.fc-box-text {\n  margin: 0;\n  font-size: 12px;\n  color: #475569;\n  line-height: 1.5;\n}\n\n.fc-expand {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 11px;\n  color: #3b82f6;\n  cursor: pointer;\n  text-decoration: underline;\n  margin-left: 2px;\n}\n\n/* Box accent colours */\n.fc-box-blue   { border-left-color: #3b82f6; }\n.fc-box-purple { border-left-color: #8b5cf6; }\n.fc-box-green  { border-left-color: #22c55e; }\n.fc-box-amber  { border-left-color: #f59e0b; }\n\n/* Conditional / disabled step styling */\n.fc-box-conditional {\n  border-style: dashed;\n}\n.fc-box-disabled {\n  opacity: 0.45;\n  border-left-color: #94a3b8;\n}\n.fc-badge-conditional {\n  background: #fef3c7 !important;\n  color: #92400e !important;\n}\n.fc-badge-disabled {\n  background: #fee2e2 !important;\n  color: #991b1b !important;\n}\n\n/* ── Vertical arrow ──────────────────────────────────────────────────────── */\n\n.fc-arrow {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  min-height: 36px;\n  position: relative;\n}\n\n.fc-arrow-label {\n  font-size: 10px;\n  color: #94a3b8;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: #fff;\n  padding: 0 4px;\n  position: relative;\n  z-index: 1;\n}\n\n/* Vertical line + arrowhead drawn with pseudo-elements */\n.fc-arrow::before {\n  content: '';\n  width: 2px;\n  flex: 1;\n  min-height: 16px;\n  background: #94a3b8;\n}\n\n.fc-arrow::after {\n  content: '';\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 7px solid #94a3b8;\n}\n\n/* ── Decision diamond ────────────────────────────────────────────────────── */\n\n.fc-diamond-wrap {\n  display: flex;\n  justify-content: center;\n  padding: 6px 0;\n}\n\n.fc-diamond {\n  width: 118px;\n  height: 118px;\n  background: #fffbeb;\n  border: 2px solid #f59e0b;\n  border-radius: 4px;\n  transform: rotate(45deg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fc-diamond-text {\n  transform: rotate(-45deg);\n  font-size: 11px;\n  font-weight: 700;\n  color: #78350f;\n  text-align: center;\n  max-width: 88px;\n  line-height: 1.3;\n  padding: 4px;\n}\n\n/* ── Branch row below a diamond ──────────────────────────────────────────── */\n\n.fc-branch-row {\n  display: grid;\n  grid-template-columns: 1fr 60px 1fr;\n  width: 520px;\n  align-items: start;\n}\n\n/* Left branch column */\n.fc-branch-left {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  padding-right: 0;\n}\n\n/* Right branch column */\n.fc-branch-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  padding-left: 0;\n}\n\n/* Center column — just the continue arrow */\n.fc-branch-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.fc-branch-empty {\n  min-width: 1px;\n}\n\n/* Branch label sits above the horizontal line */\n.fc-branch-label-left,\n.fc-branch-label-right {\n  font-size: 10px;\n  color: #94a3b8;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 0 4px;\n}\n\n.fc-branch-label-left  { text-align: right; }\n.fc-branch-label-right { text-align: left; }\n\n/* L-shaped line: horizontal + vertical */\n.fc-branch-lines-left {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n}\n\n.fc-branch-lines-right {\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: flex-start;\n}\n\n.fc-branch-h {\n  height: 2px;\n  width: 48px;\n  background: #94a3b8;\n  margin-top: 16px;   /* align with center of the arrow line */\n}\n\n.fc-branch-v {\n  width: 2px;\n  height: 28px;\n  background: #94a3b8;\n}\n\n/* ── Terminal nodes (hangup / voicemail / goodbye / retry) ───────────────── */\n\n.fc-terminal {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 5px 12px;\n  border-radius: 4px;\n  text-align: center;\n  white-space: nowrap;\n  border: 1.5px solid transparent;\n}\n\n.fc-terminal-hangup {\n  background: #fee2e2;\n  border-color: #fca5a5;\n  color: #991b1b;\n}\n\n.fc-terminal-voicemail {\n  background: #f3e8ff;\n  border-color: #c4b5fd;\n  color: #5b21b6;\n}\n\n.fc-terminal-goodbye {\n  background: #fef3c7;\n  border-color: #fcd34d;\n  color: #78350f;\n}\n\n.fc-terminal-retry {\n  background: #dbeafe;\n  border-color: #93c5fd;\n  color: #1e40af;\n}\n\n/* ── Voicemail terminal: make it a button that scrolls ───────────────────── */\n\n.fc-terminal-link {\n  cursor: pointer;\n  background: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  border-width: 1.5px;\n  border-style: solid;\n}\n\n.fc-terminal-link:hover {\n  filter: brightness(0.94);\n}\n\n.fc-terminal-hint {\n  font-size: 9px;\n  font-weight: 400;\n  opacity: 0.7;\n  letter-spacing: 0.02em;\n}\n\n/* ── Voicemail template panel ────────────────────────────────────────────── */\n\n.vm-panel {\n  background: #fff;\n  border: 1.5px solid #e9d5ff;\n  border-radius: 10px;\n  overflow: hidden;\n  scroll-margin-top: 16px;\n}\n\n.vm-panel-header {\n  background: #faf5ff;\n  border-bottom: 1px solid #e9d5ff;\n  padding: 14px 18px 10px;\n}\n\n.vm-panel-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 700;\n  font-size: 14px;\n  color: #3b0764;\n  margin-bottom: 4px;\n}\n\n.vm-panel-icon { font-size: 18px; }\n\n.vm-panel-key {\n  font-family: monospace;\n  font-size: 11px;\n  background: #ede9fe;\n  color: #5b21b6;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n.vm-panel-desc {\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: #6b21a8;\n}\n\n.vm-placeholders {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.vm-ph-label {\n  font-size: 11px;\n  color: #7c3aed;\n  font-weight: 600;\n}\n\n.vm-ph-chip {\n  font-family: monospace;\n  font-size: 11px;\n  background: #ede9fe;\n  color: #5b21b6;\n  padding: 1px 6px;\n  border-radius: 4px;\n  cursor: default;\n}\n\n/* Individual template row */\n.vm-row {\n  padding: 12px 18px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.vm-row:last-of-type { border-bottom: none; }\n\n.vm-row-inactive { opacity: 0.55; }\n\n.vm-row-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n  gap: 8px;\n}\n\n.vm-row-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.vm-badge-inactive {\n  font-size: 10px;\n  padding: 1px 6px;\n  background: #fee2e2;\n  color: #b91c1c;\n  border-radius: 8px;\n  font-weight: 500;\n}\n\n.vm-row-actions {\n  display: flex;\n  gap: 6px;\n}\n\n.vm-row-text {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.vm-lang-row {\n  display: flex;\n  gap: 8px;\n  font-size: 13px;\n  align-items: baseline;\n}\n\n.vm-lang {\n  font-size: 10px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  min-width: 24px;\n  flex-shrink: 0;\n}\n\n.vm-missing {\n  font-size: 12px;\n  color: #94a3b8;\n  font-style: italic;\n  margin: 0;\n}\n\n/* Edit form */\n.vm-edit-form,\n.vm-new-form {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  padding: 10px 12px;\n  margin-top: 6px;\n}\n\n.vm-new-form {\n  margin: 12px 18px;\n}\n\n.vm-new-form-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 2px;\n}\n\n.vm-field {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.vm-field label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.vm-hint {\n  font-weight: 400;\n  color: #94a3b8;\n}\n\n.vm-field textarea,\n.vm-field input[type='number'] {\n  padding: 6px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 4px;\n  font-size: 13px;\n  font-family: inherit;\n  resize: vertical;\n  background: #fff;\n  color: #1e293b;\n}\n\n.vm-field textarea:focus,\n.vm-field input:focus {\n  outline: none;\n  border-color: #8b5cf6;\n  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.15);\n}\n\n.vm-form-actions {\n  display: flex;\n  gap: 8px;\n}\n\n/* Inactive section */\n.vm-inactive-section {\n  padding: 8px 18px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.vm-inactive-section summary {\n  font-size: 12px;\n  color: #94a3b8;\n  cursor: pointer;\n}\n\n/* Notifications */\n.vm-success {\n  padding: 6px 10px;\n  background: #f0fdf4;\n  border: 1px solid #86efac;\n  border-radius: 4px;\n  color: #166534;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.vm-error {\n  padding: 6px 10px;\n  background: #fff0f0;\n  border: 1px solid #fca5a5;\n  border-radius: 4px;\n  color: #b91c1c;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.vm-loading {\n  font-size: 13px;\n  color: #64748b;\n  padding: 12px 18px;\n}\n\n/* Shared buttons */\n.vm-btn-edit {\n  padding: 3px 10px;\n  font-size: 12px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #374151;\n}\n.vm-btn-edit:hover { border-color: #8b5cf6; color: #5b21b6; }\n\n.vm-btn-deactivate {\n  padding: 3px 10px;\n  font-size: 12px;\n  background: #fff;\n  border: 1px solid #fca5a5;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #b91c1c;\n}\n.vm-btn-deactivate:hover { background: #fff0f0; }\n\n.vm-btn-save {\n  padding: 5px 16px;\n  background: #7c3aed;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  cursor: pointer;\n}\n.vm-btn-save:hover:not(:disabled) { background: #6d28d9; }\n.vm-btn-save:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.vm-btn-cancel {\n  padding: 5px 14px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  font-size: 13px;\n  cursor: pointer;\n  color: #374151;\n}\n.vm-btn-cancel:hover { border-color: #94a3b8; }\n\n.vm-btn-add {\n  display: block;\n  width: calc(100% - 36px);\n  margin: 10px 18px;\n  padding: 7px;\n  background: #fff;\n  border: 1px dashed #c4b5fd;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #5b21b6;\n  cursor: pointer;\n  text-align: center;\n}\n.vm-btn-add:hover { background: #faf5ff; border-color: #8b5cf6; }\n\n/* ── Transfer terminal ─────────────────────────────────────────────────────── */\n\n.fc-terminal-transfer {\n  background: #dbeafe;\n  border-color: #93c5fd;\n  color: #1e40af;\n}\n\n/* ── Company selector ──────────────────────────────────────────────────────── */\n\n.fc-company-selector {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n}\n\n.fc-company-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n  white-space: nowrap;\n}\n\n.fc-company-input {\n  width: 120px;\n  padding: 5px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 4px;\n  font-size: 13px;\n  font-family: inherit;\n  background: #fff;\n  color: #1e293b;\n}\n.fc-company-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n}\n\n/* ── Searchable company combobox ─────────────────────────────────────────── */\n\n.fc-company-combo {\n  position: relative;\n  flex: 1 1 auto;\n  max-width: 380px;\n}\n\n.fc-company-search {\n  width: 100%;\n  box-sizing: border-box;\n}\n.fc-company-search:disabled {\n  background: #f1f5f9;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.fc-company-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 30;\n  margin: 0;\n  padding: 4px;\n  list-style: none;\n  max-height: 280px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.15);\n}\n\n.fc-company-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 7px 10px;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #1e293b;\n  cursor: pointer;\n}\n.fc-company-option-active {\n  background: #eff6ff;\n}\n.fc-company-option-selected {\n  font-weight: 600;\n}\n.fc-company-option-selected .fc-company-option-name::before {\n  content: '\\2713\\00a0';\n  color: #2563eb;\n}\n\n.fc-company-option-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.fc-company-option-id {\n  flex: none;\n  font-size: 11px;\n  color: #94a3b8;\n  font-variant-numeric: tabular-nums;\n}\n\n.fc-company-empty,\n.fc-company-more {\n  padding: 8px 10px;\n  font-size: 12px;\n  color: #94a3b8;\n}\n.fc-company-more {\n  border-top: 1px solid #f1f5f9;\n  margin-top: 2px;\n}\n\n.fc-company-loading {\n  font-size: 12px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.fc-company-btn {\n  padding: 5px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  background: #3b82f6;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.fc-company-btn:hover:not(:disabled) { background: #2563eb; }\n.fc-company-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.fc-company-btn-clear {\n  background: #fff;\n  color: #64748b;\n  border: 1px solid #e2e8f0;\n}\n.fc-company-btn-clear:hover:not(:disabled) { background: #f1f5f9; border-color: #94a3b8; }\n\n.fc-company-banner {\n  padding: 8px 14px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #1e40af;\n}\n\n/* ── Config summary panel ──────────────────────────────────────────────────── */\n\n.fc-config-panel {\n  background: #fff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.fc-config-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.fc-config-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.fc-config-source {\n  font-size: 11px;\n  padding: 2px 8px;\n  background: #dbeafe;\n  color: #1e40af;\n  border-radius: 8px;\n  font-weight: 500;\n}\n\n.fc-config-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 1px;\n  background: #f1f5f9;\n  padding: 1px;\n}\n\n.fc-config-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 12px;\n  background: #fff;\n  font-size: 12px;\n}\n\n.fc-config-override {\n  background: #fffbeb;\n}\n\n.fc-config-label {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.fc-config-value {\n  color: #1e293b;\n  font-weight: 600;\n  font-family: monospace;\n  font-size: 12px;\n}\n\n.fc-config-toggle {\n  font-weight: 600;\n  font-size: 11px;\n  padding: 1px 6px;\n  border-radius: 4px;\n}\n.fc-toggle-on { background: #dcfce7; color: #166534; }\n.fc-toggle-off { background: #fee2e2; color: #991b1b; }\n\n.fc-config-sections {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  padding: 8px 14px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.fc-config-sections-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.fc-config-section-chip {\n  font-family: monospace;\n  font-size: 11px;\n  padding: 1px 6px;\n  background: #f1f5f9;\n  color: #334155;\n  border-radius: 4px;\n}\n\n/* ── Optional sections panel ───────────────────────────────────────────────── */\n\n.fc-sections-panel {\n  background: #fff;\n  border: 1.5px solid #e9d5ff;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.fc-sections-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  background: #faf5ff;\n  border-bottom: 1px solid #e9d5ff;\n}\n\n.fc-sections-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #3b0764;\n}\n\n.fc-sections-count {\n  font-size: 11px;\n  color: #6b21a8;\n}\n\n.fc-sections-list {\n  padding: 4px 0;\n}\n\n.fc-section-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 16px;\n  border-bottom: 1px solid #f3f4f6;\n  font-size: 12px;\n}\n.fc-section-row:last-child { border-bottom: none; }\n\n.fc-section-order {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #ede9fe;\n  color: #5b21b6;\n  border-radius: 50%;\n  font-size: 10px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.fc-section-key {\n  font-family: monospace;\n  font-size: 11px;\n  color: #64748b;\n  min-width: 120px;\n}\n\n.fc-section-label {\n  flex: 1;\n  color: #1e293b;\n  font-weight: 500;\n}\n\n.fc-section-qcount {\n  font-size: 11px;\n  color: #64748b;\n  font-weight: 600;\n  padding: 1px 6px;\n  background: #f1f5f9;\n  border-radius: 8px;\n}\n\n/* ── Per-company question customizer ─────────────────────────────────────── */\n.qc-panel {\n  margin-top: 24px;\n  padding: 16px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n}\n.qc-panel.qc-empty {\n  color: #64748b;\n  font-size: 13px;\n  background: #f8fafc;\n}\n.qc-header {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-bottom: 12px;\n}\n.qc-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1e293b;\n}\n.qc-sub {\n  font-size: 12px;\n  color: #64748b;\n}\n.qc-row {\n  padding: 10px 0;\n  border-top: 1px solid #eef2f7;\n}\n.qc-row:first-of-type {\n  border-top: none;\n}\n.qc-row-off {\n  opacity: 0.6;\n}\n.qc-row-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n.qc-row-id {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.qc-ident {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12px;\n  color: #0f172a;\n  background: #f1f5f9;\n  padding: 2px 6px;\n  border-radius: 6px;\n}\n.qc-section {\n  font-size: 11px;\n  color: #64748b;\n}\n.qc-badge-override,\n.qc-badge-required,\n.qc-badge-off {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding: 1px 6px;\n  border-radius: 8px;\n}\n.qc-badge-override { background: #dbeafe; color: #1d4ed8; }\n.qc-badge-required { background: #f1f5f9; color: #64748b; }\n.qc-badge-off      { background: #fee2e2; color: #b91c1c; }\n.qc-row-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.qc-text {\n  margin: 6px 0 0;\n  font-size: 13px;\n  color: #334155;\n}\n/* Toggle switch */\n.qc-switch {\n  position: relative;\n  display: inline-block;\n  width: 38px;\n  height: 20px;\n}\n.qc-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.qc-switch-slider {\n  position: absolute;\n  cursor: pointer;\n  inset: 0;\n  background: #cbd5e1;\n  border-radius: 20px;\n  transition: 0.2s;\n}\n.qc-switch-slider::before {\n  content: '';\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  left: 2px;\n  bottom: 2px;\n  background: #fff;\n  border-radius: 50%;\n  transition: 0.2s;\n}\n.qc-switch input:checked + .qc-switch-slider {\n  background: #16a34a;\n}\n.qc-switch input:checked + .qc-switch-slider::before {\n  transform: translateX(18px);\n}\n.qc-switch input:disabled + .qc-switch-slider {\n  opacity: 0.5;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
